import { Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import { CreateTicketAutocomplete } from "./TicketAutocomplete";
import { useFormContext } from "react-hook-form";
import { useGetAttributeTags } from "controller";
import { CloseIcon } from "components";

export const TagsComponent = () => {
  const theme = useTheme();
  const { control, setValue: setFormValue, watch } = useFormContext();
  const { data: tagData } = useGetAttributeTags({});
  const [searchQuery, setSearchQuery] = React.useState("");
  const [value, setValue] = React.useState<Array<any>>([]);
  const watchValue = watch("tags");
  const itemContains = (id: string) => {
    return value?.some((item) => item.mapping_id === id);
  };
  const handleTagDelete = (id: string) => {
    setValue((prev) => prev?.filter((item) => item.mapping_id !== id));

    setFormValue(
      "tags",
      value?.filter((item) => item.mapping_id !== id),
    );
  };

  return (
    <Stack sx={{ p: "16px", gap: "16px" }}>
      <CreateTicketAutocomplete
        name={"tags"}
        multiple
        freeSolo={false}
        filterSelectedOptions
        control={control}
        fullWidth
        isOptionEqualToValue={(option, value) =>
          option["mapping_id"] === value["mapping_id"]
        }
        options={tagData?.result || []}
        placeholder="Select tags"
        value={value}
        onChange={(event: any, newValue: any) => {
          setValue(newValue);
          setFormValue("tags", newValue);
        }}
        labelMappingKey="tag_name"
        valueMappingKey="mapping_id"
        getOptionLabel={(option) => {
          if (!option) return "";
          return typeof option === "string" ? option : `${option.tag_name}`;
        }}
        inputStyle={{
          color: theme.palette.lightBg.low,
          backgroundColor: theme.palette.neutral["005"],
          height: "32px",
          border: `1px solid ${theme.palette.neutral["015"]}`,
          borderRadius: "4px",
        }}
        onInputChange={(event: any, newInputValue: any) => {
          setSearchQuery(newInputValue);
        }}
        deleteItemOnBackspace={false}
      />
      <Stack direction={"row"} flexWrap={"wrap"} sx={{ gap: "8px" }}>
        {watchValue?.map((tag: any) => (
          <Stack
            key={tag.mapping_id}
            direction="row"
            gap="8px"
            sx={{
              p: "4px 8px 4px 12px",
              borderRadius: "4px",
              backgroundColor: theme.palette.secondary["purple-tint-3"],
              maxHeight: "24px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                maxWidth: "70px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              variant="caption-xs"
              color={theme.palette.purple.main}
            >
              {tag.tag_name}
            </Typography>
            <CloseIcon
              onClick={() => {
                handleTagDelete(tag.mapping_id);
              }}
              sx={{ cursor: "pointer" }}
              fontSize="small"
              htmlColor={theme.palette.purple.main}
            />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
